(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["portl-ajax-list"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  if (window.__portlAjaxList) return;

  // Bail (keep native links) if the platform lacks what we need.
  if (!('fetch' in window) || !('DOMParser' in window) ||
      !window.history || !window.history.pushState) return;

  // Don't hijack navigation inside the theme editor — merchants should see the
  // real URLs render fully while customizing.
  if (window.Shopify && window.Shopify.designMode) return;

  window.__portlAjaxList = true;

  var ROOT = '[data-portl-ajax]';
  var inflight = null;

  function basePath(root) {
    var b = root.getAttribute('data-portl-ajax-base');
    if (b) { try { return new URL(b, location.href).pathname; } catch (e) {} }
    return location.pathname;
  }

  function setBusy(root, on) {
    root.classList.toggle('portl-ajax-loading', !!on);
    var regions = root.querySelectorAll('[data-portl-ajax-swap]');
    for (var i = 0; i < regions.length; i++) {
      regions[i].setAttribute('aria-busy', on ? 'true' : 'false');
    }
  }

  function swap(root, doc) {
    var nextRoot = doc.querySelector(ROOT);
    if (!nextRoot) return false;
    var regions = root.querySelectorAll('[data-portl-ajax-swap]');
    var swapped = 0;
    for (var i = 0; i < regions.length; i++) {
      var key = regions[i].getAttribute('data-portl-ajax-swap');
      var next = nextRoot.querySelector('[data-portl-ajax-swap="' + key + '"]');
      if (next) { regions[i].replaceWith(next); swapped++; }
    }
    var title = doc.querySelector('title');
    if (title) document.title = title.textContent;
    return swapped > 0;
  }

  // Lighter payload: when the section exposes its id we hit Shopify's Section
  // Rendering API (?section_id=…), which returns ONLY this section's HTML
  // instead of the whole document. Falls back to the plain URL otherwise.
  function fetchUrlFor(displayUrl, root) {
    var sid = root.getAttribute('data-portl-ajax-section');
    if (!sid) return displayUrl;
    try {
      var u = new URL(displayUrl, location.href);
      u.searchParams.set('section_id', sid);
      return u.href;
    } catch (e) { return displayUrl; }
  }

  function go(displayUrl, root, opts) {
    opts = opts || {};
    if (inflight) { try { inflight.abort(); } catch (e) {} }
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    inflight = ctrl;
    setBusy(root, true);

    fetch(fetchUrlFor(displayUrl, root), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (res) {
        if (!res.ok) throw new Error('status ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (!swap(root, doc)) throw new Error('missing markup');
        inflight = null;
        // Push the clean, user-facing URL (never the ?section_id= request URL).
        if (opts.push !== false) history.pushState({ pAjax: 1 }, '', displayUrl);
        setBusy(root, false);
        if (opts.scroll) {
          var y = root.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return; // superseded by a newer click
        window.location.href = displayUrl;            // graceful full-navigation fallback
      });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 ||
        e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var root = e.target.closest ? e.target.closest(ROOT) : null;
    if (!root) return;

    var link = e.target.closest('a[href]');
    if (!link || !root.contains(link)) return;
    if (!link.closest('[data-portl-ajax-nav]')) return; // only marked nav links
    if (link.getAttribute('aria-disabled') === 'true' ||
        link.classList.contains('is-disabled') ||
        link.hasAttribute('data-portl-ajax-ignore')) return;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;

    var url;
    try { url = new URL(href, location.href); } catch (e2) { return; }
    if (url.origin !== location.origin) return; // never hijack off-site links

    e.preventDefault();
    go(url.href, root, { scroll: !!link.closest('[data-portl-ajax-scroll]') });
  });

  window.addEventListener('popstate', function () {
    var root = document.querySelector(ROOT);
    if (!root) return;
    if (location.pathname.indexOf(basePath(root)) === 0) {
      go(location.href, root, { push: false, scroll: false });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["portl-buy-button"] && !Shopify.designMode) return;
  try {
    /* ============================================================
     Unified Buy Now / Sold Out controller.
     Mirrors the Bottom Sticky Bar: listens for the SAME
     `portl:variant-change` event (dispatched by portl-theme.js) and
     flips every [data-portl-buy] CTA's label + disabled state from
     its per-variant availability payload. Runs once (idempotent).
     ============================================================ */
  (function () {
    // Enabled state (buy OR preorder) — identical purchase affordance, only the
    // label differs. Sold-out disables a form-submit button / points a link at
    // the PDP. Split out so preorder reuses the exact existing "available" path.
    function setEnabled(btn, labelEl, isButton, label) {
      btn.classList.remove('is-sold-out');
      if (labelEl) labelEl.textContent = label;
      if (isButton) {
        btn.removeAttribute('disabled');
      } else {
        var bh = btn.getAttribute('data-buy-href');
        if (bh) btn.setAttribute('href', bh);
      }
    }
    function setSoldOut(btn, labelEl, isButton) {
      btn.classList.add('is-sold-out');
      if (labelEl) labelEl.textContent = btn.getAttribute('data-soldout-label') || 'Sold Out';
      if (isButton) {
        btn.setAttribute('disabled', 'disabled');   // form-submit CTA can't navigate
      } else {
        btn.setAttribute('href', btn.getAttribute('data-soldout-href') || '#');
      }
    }

    function apply(btn, vid) {
      var labelEl = btn.querySelector('[data-portl-buy-label]');
      var isButton = btn.tagName === 'BUTTON';

      // Preferred: 3-state map { id: 'buy' | 'preorder' | 'sold_out' }.
      var stateRaw = btn.getAttribute('data-variants-state');
      if (stateRaw) {
        var states;
        try { states = JSON.parse(stateRaw); } catch (e) { return; }
        var st = states[String(vid)];
        if (!st) return;
        if (st === 'sold_out') {
          setSoldOut(btn, labelEl, isButton);
        } else if (st === 'preorder') {
          setEnabled(btn, labelEl, isButton, btn.getAttribute('data-preorder-label') || 'Preorder');
        } else {
          setEnabled(btn, labelEl, isButton, btn.getAttribute('data-buy-label') || 'Buy Now');
        }
        return;
      }

      // Legacy fallback: boolean availability map (behavior unchanged).
      var raw = btn.getAttribute('data-variants-avail');
      if (!raw) return;
      var data;
      try { data = JSON.parse(raw); } catch (e) { return; }
      if (!(String(vid) in data)) return;
      if (data[String(vid)] !== false) {
        setEnabled(btn, labelEl, isButton, btn.getAttribute('data-buy-label') || 'Buy Now');
      } else {
        setSoldOut(btn, labelEl, isButton);
      }
    }

    function onChange(e) {
      var vid = e && e.detail && e.detail.variantId;
      if (!vid) return;
      document.querySelectorAll('[data-portl-buy]').forEach(function (btn) {
        apply(btn, vid);
      });
    }

    if (!window.__portlBuyBtnBound) {
      window.__portlBuyBtnBound = true;
      document.addEventListener('portl:variant-change', onChange);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["portl-scroll-cue"] && !Shopify.designMode) return;
  try {
    /* Hero scroll cue → smooth-scroll to the next content section.
     One delegated listener covers every [data-scroll-next] cue on the
     page (Home + UltraGym Explore heroes). The cue is a <button>, so on
     the UltraGym hero it already matches the video-popup handler's
     SKIP_SELECTORS — clicking it scrolls instead of opening the popup. */
  (function () {
    function nextSectionOf(el) {
      var sec = el.closest('.shopify-section') || el.closest('section');
      var n = sec ? sec.nextElementSibling : null;
      while (n && n.getBoundingClientRect().height < 1) { n = n.nextElementSibling; }
      return n;
    }
    document.addEventListener('click', function (e) {
      var cue = e.target.closest('[data-scroll-next]');
      if (!cue) return;
      e.preventDefault();
      var next = nextSectionOf(cue);
      if (next) {
        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollBy({ top: Math.round(window.innerHeight * 0.9), behavior: 'smooth' });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["portl-sticky-buy"] && !Shopify.designMode) return;
  try {
    /* ============================================================
     Sticky-buy controller.
     • IntersectionObserver per bar: shows when all targets off-screen
     • Listens for portl:variant-change events (PDP radios + Explore
       chips emit this) and updates price / EMI / compare / image /
       title / cta-href from the bar's pre-rendered variants payload.
     • Safe to run multiple times (data-* guard).
     ============================================================ */
  (function () {
    function applyVariant(bar, vid) {
      if (!bar || !vid) return;
      var raw = bar.getAttribute('data-variants');
      if (!raw) return;
      var data;
      try { data = JSON.parse(raw); } catch (e) { return; }
      var info = data[String(vid)];
      if (!info) return;

      function setText(sel, val) {
        bar.querySelectorAll(sel).forEach(function (el) {
          el.textContent = val || '';
        });
      }
      function toggleEmpty(sel, val) {
        bar.querySelectorAll(sel).forEach(function (el) {
          if (val) el.classList.remove('is-empty');
          else el.classList.add('is-empty');
        });
      }

      setText('[data-cart-price]', info.price);
      setText('[data-cart-emi-amount]', info.emiAmount);
      toggleEmpty('[data-cart-emi-amount]', info.emiAmount);
      setText('[data-cart-title]', info.title);
      // The visible price/EMI is now rendered by the portl-price-emi
      // snippet (which has its own children — .portl-pe__price and
      // .portl-pe__emi). Propagate the data-cart-* values into those
      // visible elements so the bar updates on variant change.
      var peInside = bar.querySelector('.portl-pe');
      if (peInside) {
        var peP = peInside.querySelector('.portl-pe__price');
        var peE = peInside.querySelector('.portl-pe__emi');
        if (peP && info.price) peP.textContent = info.price;
        if (peE && info.emiAmount) peE.textContent = info.emiAmount;
      }
      // State-based promo line: show the variant's text, or hide when empty
      // (e.g. sold-out). Never leaves an empty element / gap.
      bar.querySelectorAll('[data-sticky-promo]').forEach(function (el) {
        var promo = info.promo || '';
        el.textContent = promo;
        if (promo) { el.removeAttribute('hidden'); }
        else { el.setAttribute('hidden', ''); }
      });
      // data-cart-emi (legacy full EMI line) and data-cart-compare
      // (strikethrough) are no longer rendered.

      // Image swap — fade then load to avoid flicker
      bar.querySelectorAll('[data-cart-image]').forEach(function (img) {
        if (!info.image || img.getAttribute('src') === info.image) return;
        img.classList.add('is-loading');
        var swap = new Image();
        swap.onload = function () {
          img.setAttribute('src', info.image);
          requestAnimationFrame(function () { img.classList.remove('is-loading'); });
        };
        swap.onerror = function () { img.classList.remove('is-loading'); };
        swap.src = info.image;
      });

      // CTA href + sold-out state. When sold out the CTA is DISABLED
      // (greyed + non-clickable); when available it's restored.
      bar.querySelectorAll('[data-cart-cta-href]').forEach(function (el) {
        if (info.href) el.setAttribute('href', info.href);
      });
      // 3-state: prefer info.state ('buy'|'preorder'|'sold_out'); fall back to
      // the legacy boolean when an older payload has no state. Only sold_out
      // disables — preorder stays enabled (label only), same as Buy Now.
      var st = info.state || (info.available === false ? 'sold_out' : 'buy');
      var soldOut = st === 'sold_out';
      bar.classList.toggle('is-sold-out', soldOut);
      bar.querySelectorAll('[data-cart-cta]').forEach(function (cta) {
        if (soldOut) {
          // <button> honours disabled natively; <a> uses aria-disabled
          // + tabindex (CSS pointer-events:none blocks the click).
          if (cta.tagName === 'BUTTON') cta.setAttribute('disabled', '');
          cta.setAttribute('aria-disabled', 'true');
          if (cta.tagName === 'A') cta.setAttribute('tabindex', '-1');
        } else {
          cta.removeAttribute('disabled');
          cta.removeAttribute('aria-disabled');
          if (cta.tagName === 'A') cta.removeAttribute('tabindex');
        }
      });
      bar.querySelectorAll('[data-cart-cta-label]').forEach(function (el) {
        if (st === 'sold_out') el.textContent = 'Sold Out';
        else if (st === 'preorder') el.textContent = el.getAttribute('data-preorder-label') || 'Preorder';
        else el.textContent = el.getAttribute('data-buy-label') || el.textContent;
      });

      // Stock pill
      bar.querySelectorAll('[data-cart-availability]').forEach(function (el) {
        el.setAttribute('data-available', info.available === false ? 'false' : 'true');
        el.textContent = info.available === false ? 'Sold out' : 'In stock';
      });
    }

    // ── Visual-viewport bottom sync (iOS toolbar / keyboard) ──────────
    // Measure the gap between the VISUAL viewport bottom and the LAYOUT
    // viewport bottom (where `bottom:0` sits), then shift each VISIBLE bar
    // by exactly that gap so its bottom edge stays glued to the visible
    // edge — no jump, no exposed background — throughout the iOS toolbar
    // expand/collapse, keyboard, and orientation changes.
    //
    // • Signed shift: positive → visible bottom is BELOW the layout bottom
    //   (bar nudged down); negative → above (bar nudged up, e.g. keyboard).
    //   Because we shift by the *measured* remaining gap, there is nothing
    //   to over-correct — no gap means no shift.
    // • Only VISIBLE bars are shifted; a hidden bar sits fully off-screen
    //   (transform 110%) and a large keyboard gap must not drag it back in.
    // • rAF-throttled + last-value cached, so scrolling stays cheap and
    //   desktop/Android (gap ≈ 0) is an effective no-op.
    var vvRaf = 0;
    function syncViewport() {
      vvRaf = 0;
      var vv = window.visualViewport;
      var shift = 0;
      if (vv) {
        shift = (vv.offsetTop + vv.height) - document.documentElement.clientHeight;
        if (shift > -0.5 && shift < 0.5) shift = 0; // ignore sub-pixel noise
      }
      var value = shift ? (Math.round(shift) + 'px') : '0px';
      document.querySelectorAll('[data-portl-sticky-buy]').forEach(function (bar) {
        var target = bar.classList.contains('is-visible') ? value : '0px';
        if (bar.__psbVV === target) return;       // skip redundant writes
        bar.__psbVV = target;
        bar.style.setProperty('--psb-vv-shift', target);
      });
    }
    function scheduleViewport() { if (!vvRaf) vvRaf = requestAnimationFrame(syncViewport); }

    function init() {
      var bars = document.querySelectorAll('[data-portl-sticky-buy]');
      if (!bars.length) return;

      bars.forEach(function (bar) {
        if (bar.dataset.stickyInit === '1') return;
        bar.dataset.stickyInit = '1';

        // Show/hide via IntersectionObserver
        var sel = bar.getAttribute('data-watch') || '[data-sticky-watch]';
        var targets = document.querySelectorAll(sel);
        if (targets.length) {
          var visibleTargets = new Set();
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) visibleTargets.add(e.target);
              else visibleTargets.delete(e.target);
            });
            var shouldShow = visibleTargets.size === 0;
            bar.classList.toggle('is-visible', shouldShow);
            bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
            // Keep focusable CTAs out of the tab order while the bar is hidden.
            if (shouldShow) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
            document.body.classList.toggle('portl-sticky-buy-visible', shouldShow);
            // A bar just became visible — apply the current viewport shift so
            // it snaps to the visible bottom edge as it slides in.
            scheduleViewport();
          }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
          targets.forEach(function (t) { io.observe(t); });
        }

        // Sold-out click-guard: when the bar is sold out the CTA is disabled,
        // so this is a defensive backstop — block the click (no submit, no
        // navigation). Works for both the form-submit button and the link CTA.
        var cta = bar.querySelector('[data-cart-cta]');
        if (cta) {
          cta.addEventListener('click', function (e) {
            if (!bar.classList.contains('is-sold-out')) return;
            e.preventDefault();
            e.stopPropagation();
          });
        }
      });

      // Bind once globally — every sticky bar listens for the same event
      if (!window.__portlStickyBuyBound) {
        window.__portlStickyBuyBound = true;
        document.addEventListener('portl:variant-change', function (e) {
          var vid = e && e.detail && e.detail.variantId;
          if (!vid) return;
          document.querySelectorAll('[data-portl-sticky-buy]').forEach(function (bar) {
            applyVariant(bar, vid);
          });
        });
      }

      // Visual-viewport listeners — bound once. `visualViewport` resize/scroll
      // catch the iOS toolbar + keyboard; window scroll/resize back them up
      // during momentum; orientationchange re-measures (twice — the geometry
      // settles a beat after the rotate). Absent visualViewport → no-op.
      if (!window.__portlStickyVVBound) {
        window.__portlStickyVVBound = true;
        var vv = window.visualViewport;
        if (vv) {
          vv.addEventListener('resize', scheduleViewport);
          vv.addEventListener('scroll', scheduleViewport);
        }
        window.addEventListener('scroll', scheduleViewport, { passive: true });
        window.addEventListener('resize', scheduleViewport, { passive: true });
        window.addEventListener('orientationchange', function () {
          scheduleViewport();
          setTimeout(scheduleViewport, 300);
        });
      }
      scheduleViewport();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["portl-video-autoplay"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__portlVideoAutoplay) return;      /* define + init once */
  window.__portlVideoAutoplay = true;

  var SELECTOR = '[data-portl-autoplay-video]';
  var RATIO = 0.25;                              /* play once ≥25% visible */
  var pending = (typeof Set !== 'undefined') ? new Set() : null; /* blocked → retry on gesture */
  var unlocked = false;

  function inView(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    return r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
  }

  function playSafe(v) {
    if (!v || (!v.paused && !v.ended)) return;
    if (v.dataset.portlUserPaused === '1') return;   /* respect a manual pause */
    v.muted = true; v.defaultMuted = true;
    var p;
    try { p = v.play(); } catch (e) { p = null; }
    if (p && typeof p.then === 'function') {
      p.then(function () { if (pending) pending.delete(v); })
       .catch(function () { if (pending) pending.add(v); }); /* autoplay blocked (iOS) → retry on gesture */
    }
  }
  function pauseSafe(v) { if (v && !v.paused) { try { v.pause(); } catch (e) {} } }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting && e.intersectionRatio >= RATIO) playSafe(e.target);
      else pauseSafe(e.target);
    });
  }, { threshold: [0, RATIO, 0.5] }) : null;

  function enhance(v) {
    if (v.__portlAP) return; v.__portlAP = true;
    /* Mobile autoplay needs these as real attributes, not just properties. */
    v.muted = true; v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.setAttribute('disablepictureinpicture', '');
    /* iOS Safari sometimes rejects the first play() before enough data — retry
       at buffer milestones, but only while the element is actually visible. */
    ['loadedmetadata', 'loadeddata', 'canplay'].forEach(function (ev) {
      v.addEventListener(ev, function () { if (inView(v)) playSafe(v); }, { passive: true });
    });
    if (io) io.observe(v);
    else if (inView(v)) playSafe(v);            /* no IO support → eager play in-view */
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(nodes, enhance);
  }

  /* iOS Low-Power / strict autoplay: retry blocked videos on the first user
     gesture (kept non-once so a genuinely late gesture still recovers them). */
  function unlock() {
    if (unlocked || !pending) return;
    unlocked = true;
    pending.forEach(function (v) { if (inView(v)) playSafe(v); });
  }
  ['touchstart', 'touchend', 'pointerdown', 'click', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, unlock, { passive: true });
  });

  /* Battery-friendly: pause when the tab is hidden, resume the in-view ones. */
  document.addEventListener('visibilitychange', function () {
    var nodes = document.querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(nodes, function (v) {
      if (document.hidden) pauseSafe(v);
      else if (inView(v)) playSafe(v);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }
  /* Theme editor: re-scan the re-rendered section (idempotent via __portlAP). */
  document.addEventListener('shopify:section:load', function (e) { scan(e.target || document); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["portl-video-controls"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__portlVideoControls) return;            /* define + auto-init once */
  window.__portlVideoControls = true;

  var SEEK = 10;          /* seconds per double-tap */
  var KEY_SEEK = 5;       /* seconds per arrow key  */
  var DBLTAP_MS = 300;    /* double-tap window       */
  var FB_MS = 750;        /* feedback overlay lifetime (covers the 0.7s ripple) */

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    var m = Math.floor(t / 60), s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }
  function finiteDur(v) { return v && isFinite(v.duration) && v.duration > 0; }

  function enhance(root) {
    if (!root || root.dataset.vcReady === '1') return;
    var media = root.parentElement;
    if (!media) return;
    root.dataset.vcReady = '1';

    var fillEl   = root.querySelector('[data-portl-vc-fill]');
    var buffEl   = root.querySelector('[data-portl-vc-buffered]');
    var thumbEl  = root.querySelector('[data-portl-vc-thumb]');
    var barEl    = root.querySelector('[data-portl-vc-bar]');
    var trackEl  = barEl ? barEl.querySelector('.portl-vc__track') : null;
    var fbBack   = root.querySelector('[data-portl-vc-fb="back"]');
    var fbFwd    = root.querySelector('[data-portl-vc-fb="fwd"]');
    var zoneBack = root.querySelector('[data-portl-vc-zone="back"]');
    var zoneFwd  = root.querySelector('[data-portl-vc-zone="fwd"]');

    function videos() { return media.querySelectorAll('video'); }

    /* Active video = the one that's actually playing; else the visible one;
       else the first. Handles UltraGym's two swappable <video>s. */
    function activeVideo() {
      var vids = videos(), i;
      for (i = 0; i < vids.length; i++) { if (!vids[i].paused && !vids[i].ended) return vids[i]; }
      for (i = 0; i < vids.length; i++) { if (vids[i].offsetParent !== null) return vids[i]; }
      return vids[0] || null;
    }

    /* ── Seek + feedback ─────────────────────────────────────────── */
    var fbTimers = {};
    function flashFeedback(el) {
      if (!el) return;
      el.classList.add('is-active');
      clearTimeout(fbTimers[el === fbBack ? 'b' : 'f']);
      fbTimers[el === fbBack ? 'b' : 'f'] = setTimeout(function () {
        el.classList.remove('is-active');
      }, FB_MS);
    }
    function seekBy(delta) {
      var v = activeVideo();
      if (!finiteDur(v)) return;          /* don't seek live/HLS-without-duration */
      var t = v.currentTime + delta;
      if (t < 0) t = 0;
      if (t > v.duration) t = v.duration;
      v.currentTime = t;                  /* setting currentTime does NOT pause */
      flashFeedback(delta < 0 ? fbBack : fbFwd);
      updateUI();
    }

    /* Double-tap detection on each zone. Single tap is intentionally a no-op
       (matches the popup's existing "tap does nothing" behaviour). */
    function wireZone(zone, delta) {
      if (!zone) return;
      var last = 0;
      zone.addEventListener('click', function (e) {
        e.preventDefault();
        var now = Date.now();
        if (now - last < DBLTAP_MS) { last = 0; seekBy(delta); }
        else { last = now; }
      });
    }
    wireZone(zoneBack, -SEEK);
    wireZone(zoneFwd,  SEEK);

    /* ── Seek bar ────────────────────────────────────────────────── */
    var scrubbing = false;
    function ratioFromEvent(e) {
      if (!trackEl) return 0;
      var r = trackEl.getBoundingClientRect();
      var x = (e.clientX != null ? e.clientX : 0) - r.left;
      var ratio = r.width ? x / r.width : 0;
      return ratio < 0 ? 0 : (ratio > 1 ? 1 : ratio);
    }
    function seekToEvent(e) {
      var v = activeVideo();
      if (!finiteDur(v)) return;
      v.currentTime = ratioFromEvent(e) * v.duration;   /* keeps current play/pause state */
      updateUI();
    }
    if (barEl) {
      barEl.addEventListener('pointerdown', function (e) {
        if (!finiteDur(activeVideo())) return;
        scrubbing = true;
        root.classList.add('is-scrubbing');
        try { barEl.setPointerCapture(e.pointerId); } catch (err) {}
        seekToEvent(e);
        e.preventDefault();
      });
      barEl.addEventListener('pointermove', function (e) { if (scrubbing) seekToEvent(e); });
      function endScrub(e) {
        if (!scrubbing) return;
        scrubbing = false;
        root.classList.remove('is-scrubbing');
        try { barEl.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      barEl.addEventListener('pointerup', endScrub);
      barEl.addEventListener('pointercancel', endScrub);

      barEl.addEventListener('keydown', function (e) {
        var v = activeVideo();
        if (!finiteDur(v)) return;
        var handled = true;
        if (e.key === 'ArrowRight' || e.key === 'Up' || e.key === 'ArrowUp') v.currentTime = Math.min(v.duration, v.currentTime + KEY_SEEK);
        else if (e.key === 'ArrowLeft' || e.key === 'Down' || e.key === 'ArrowDown') v.currentTime = Math.max(0, v.currentTime - KEY_SEEK);
        else if (e.key === 'Home') v.currentTime = 0;
        else if (e.key === 'End') v.currentTime = v.duration;
        else handled = false;
        if (handled) { e.preventDefault(); updateUI(); }
      });
    }

    /* ── Progress UI ─────────────────────────────────────────────── */
    function updateUI() {
      var v = activeVideo();
      var ready = finiteDur(v);
      root.classList.toggle('is-ready', !!ready);
      if (!ready) { if (fillEl) fillEl.style.width = '0%'; if (thumbEl) thumbEl.style.left = '0%'; return; }
      var pct = (v.currentTime / v.duration) * 100;
      if (pct < 0) pct = 0; if (pct > 100) pct = 100;
      if (fillEl)  fillEl.style.width = pct + '%';
      if (thumbEl) thumbEl.style.left = pct + '%';
      if (v.buffered && v.buffered.length && buffEl) {
        var end = v.buffered.end(v.buffered.length - 1);
        buffEl.style.width = Math.min(100, (end / v.duration) * 100) + '%';
      }
      if (barEl) {
        barEl.setAttribute('aria-valuenow', Math.round(pct));
        barEl.setAttribute('aria-valuetext', fmt(v.currentTime) + ' of ' + fmt(v.duration));
      }
    }

    /* rAF loop only while a video is playing (cheap; runs only when the
       popup is open + playing — never on background pages). */
    var rafId = null;
    function loop() { updateUI(); rafId = activeVideo() && !activeVideo().paused ? requestAnimationFrame(loop) : null; }
    function startLoop() { if (rafId == null) rafId = requestAnimationFrame(loop); }
    function stopLoop() { if (rafId != null) { cancelAnimationFrame(rafId); rafId = null; } updateUI(); }

    /* Bind to every video in the container (covers the active-swap case). */
    Array.prototype.forEach.call(videos(), function (v) {
      v.addEventListener('play', startLoop);
      v.addEventListener('playing', startLoop);
      v.addEventListener('pause', stopLoop);
      v.addEventListener('ended', stopLoop);
      v.addEventListener('timeupdate', updateUI);
      v.addEventListener('progress', updateUI);
      v.addEventListener('seeked', updateUI);
      v.addEventListener('loadedmetadata', updateUI);
      v.addEventListener('durationchange', updateUI);
    });
    updateUI();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-portl-vc]');
    Array.prototype.forEach.call(roots, enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }
  /* Theme editor: re-scan when a section re-renders. */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
})();
  } catch(e) { console.error(e); }
})();

})();
